import { Config } from '../Config';
//import { parsePhoneNumber, validatePhoneNumberLength } from 'libphonenumber-js'
import { parsePhoneNumber } from 'libphonenumber-js'
import API from './ApiManager';
import { v4 as uuidv4 } from "uuid";

let currEnvStore = null;
let selCCName = "selectedCodComm";
let invoiceName = "invoiceDataValue"
let prodListName = "prodListData"
let sessionIdName = "sessId";

const FROM_COOKIE_NAME = "initialTrafficSourceType";

var ExcCatgory = {
    ORDER_CONFIRM: { val: "ORDER_CONFIRM" },
    INVOICE: { val: "INVOICE" },
    PAY_METHOD: { val: "PAY_METHOD" },
    ZUORA: { val: "ZUORA" },
    PAYPAL: { val: "PAYPAL" },
    USER: { val: "USER" },
    API_CALL: { val: "API_CALL" },
    BASKET: { val: "BASKET" },
    GENERIC: { val: "GENERIC" },
    BRIDGE: { val: "BRIDGE" },
    DOMAIN: { val: "DOMAIN" },
    REGISTRATION: {val: "REGISTRATION"}
}

var LogLvl = {
    NONE: { val: 0 },
    INFO: { val: 1 },
    ERROR: { val: 2 },
    WARN: { val: 3 },
    DEBUG: { val: 4 }
}

var ErrorMsgGen = {
    SERVER_DOWN: { msg: "Il servizio è momentaneamente non disponibile" },
    INVALID_GENERIC: { msg: "Questo campo contiene un errore" },
    EMPTY: { msg: "Questo campo non può essere vuoto" }
}

var EnmEmail = {
    OK: { msg: "" },
    KO: { msg: ErrorMsgGen.INVALID_GENERIC.msg },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg },
    NOTFREE: { msg: "L'email appartiene appartiene ad nostro cliente. Se sei il proprietario effettua il login" },
    SERVER_DOWN: { msg: ErrorMsgGen.SERVER_DOWN.msg }
};

var EnmPiva = {
    OK: { msg: "" },
    NOT_FOUND: { msg: "" },
    KO: { msg: "La partita IVA non è corretta" },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg },
    INVALID_LENGTH: { msg: "La partita IVA deve contenere 7 o 11 cifre" },
    NOTFREE: { msg: "La partita iva appartiene ad nostro cliente. Se sei il proprietario effettua il login" },
    NOCF: { msg: "Il Codice fiscale non è un valore consentito" },
    SERVER_DOWN: { msg: ErrorMsgGen.SERVER_DOWN.msg }

};

var EnmCf = {
    OK: { msg: "" },
    INVALID_LENGTH: { msg: "Il codice fiscale deve contenere 16 tra lettere e cifre." },
    NOCTRCODE: { msg: "Il codice fiscale non è valido:\n' + 'il codice di controllo non corrisponde.\n" },
    NOT_FOUND: { msg: "" },
    KO: { msg: "La partita IVA non è corretta" },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg },
    NOTFREE: { msg: "Il codice fiscale appartiene ad nostro cliente. Se sei il proprietario effettua il login" },
    SERVER_DOWN: { msg: ErrorMsgGen.SERVER_DOWN.msg }
};

var EnmPhone = {
    OK: { msg: "" },
    KO: { msg: "Il telefono non è corretto" },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg }
};

var EnmSdi = {
    OK: { msg: "" },
    KO: { msg: "Il codice SDI non è corretto" },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg },
    INVALID_LENGTH: { msg: "Il codice SDI deve essere di 7 caratteri" }
};

var EnmGen = {
    OK: { msg: "" },
    EMPTY: { msg: ErrorMsgGen.EMPTY.msg },
    KO: { msg: ErrorMsgGen.INVALID_GENERIC.msg },
		NOT_SELECTED: { msg: "Devi selezionare il valore dall'elenco" },
};

const EnmBasket = {
    OK: { msg: "" },
    EMPTY: { msg: "empty" },
    KO: { msg: "ko" },
    EMPTY_DOMAIN: { msg: "Empty domain for SDIY" },
};

var EnmPay = {
    OK: { code: "OK", msg: "" },
    OKDIRECT: { code: "OKDIRECT", msg: "" },
    OKDIRECTPREV: { code: "OKDIRECTPREV", msg: "" },
    KO: { code: "KO", msg: ErrorMsgGen.INVALID_GENERIC.msg }
};

class Ret {
    constructor(code, obj) {
        this.code = code
        this.obj = obj
    }
}

var BasketType = {
    PAY: { msg: "Solo prodotti a pagamento", code: "PAY" },
    PREV: { msg: "Solo prodotti preventivo", code: "PREV" },
    BOTH: { msg: "Carrello misto", code: "BOTH" }
};

var EnmProdType = {
    PAY: { code: "PAY", msg: "Prodotto acquistabile direttamente" },
    PREV: { code: "PREV", msg: "Prodotto di ricontatto (preventivo)" }
};


class DlgConf {
    constructor(title, description, srvCln, acOKLbl, acKOLbl, handleOK, handleKO, dimension) {
        this.title = title;
        this.description = description;
        this.srvCln = srvCln;
        this.acOKLbl = acOKLbl;
        this.acKOLbl = acKOLbl;
        this.handleOK = handleOK;
        this.handleKO = handleKO;
        this.dimension = dimension;
    }
}

var LoadingInp = {
    TYPE: "Puff",
    COLOR: "#de1e63",
    HEIGHT: 30,
    WIDTH: 30,
    TIMEOUT: 0
}

var currEnv = () => {
    if (!currEnvStore || currEnvStore.length <= 0) {
        let env = Config.envs.find(function (el) {
            return el.type === process.env.REACT_APP_IOLENV;
        })
        currEnvStore = env;
        return env;
    } else {
        return currEnvStore;
    }
}

var log = (msg, obj, level) => {
    if (currEnv().logsLevel.val >= level.val) {
        console.log(msg, obj);
    }
}

var validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(email).toLowerCase())) {
        return EnmEmail.OK;
    } else {
        return EnmEmail.KO;
    }
}


var validateSdi = (sdi) => {
    if (!sdi || sdi.length <= 0) {
        return EnmSdi.EMPTY;
    } else if (sdi && sdi.length === 7) {
        return EnmSdi.OK;
    } else {
        return EnmSdi.INVALID_LENGTH;
    }
}

var validateCf = (cf) => {
    if (cf && cf.length > 0) {
        cf = cf.toUpperCase();

        if (!/^[0-9A-Z]{16}$/.test(cf)) return EnmCf.INVALID_LENGTH;
        var map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
        var s = 0;
        for (var i = 0; i < 15; i++) {
            var c = cf.charCodeAt(i);
            if (c < 65) c = c - 48;
            else c = c - 55;
            if (i % 2 === 0) s += map[c];
            else s += c < 10 ? c : c - 10;
        }
        var atteso = String.fromCharCode(65 + (s % 26));
        if (atteso !== cf.charAt(15)) return EnmCf.NOCTRCODE;
        return EnmCf.OK;
    } else {
        return EnmCf.INVALID_LENGTH;
    }
}

/*
var validatePhone = (tel) => {
    try {
        //https://it.wikipedia.org/wiki/Prefissi_telefonici_dei_cellulari_italiani
        var pref = ['004191', '010', '011', '0121', '0122', '0123', '0124', '0125', '0131', '0141', '0142', '0143', '0144', '015', '0161', '0163', '0165', '0166', '0171', '0172', '0173', '0174', '0175', '0182', '0183', '0184', '0185', '0187', '019', '02', '030', '031', '0321', '0322', '0323', '0324', '0331', '0332', '0341', '0342', '0343', '0344', '0345', '0346', '035', '0362', '0363', '0364', '0365', '0371', '0372', '0373', '0374', '0375', '0376', '0377', '0381', '0382', '0383', '0384', '0385', '0386', '0387', '0388', '0389', '039', '040', '041', '0421', '0422', '0423', '0424', '0425', '0426', '0427', '0428', '0429', '0431', '0432', '0433', '0434', '0435', '0436', '0437', '0438', '0439', '0442', '0444', '0445', '045', '0461', '0462', '0463', '0464', '0465', '0471', '0472', '0473', '0474', '0481', '049', '050', '051', '0521', '0522', '0523', '0524', '0525', '0532', '0533', '0534', '0535', '0536', '0541', '0542', '0543', '0544', '0545', '0546', '0547', '055', '0564', '0565', '0566', '0571', '0572', '0573', '0574', '0575', '0577', '0578', '0583', '0584', '0585', '0586', '0587', '0588', '059', '06', '070', '071', '0721', '0722', '0731', '0732', '0733', '0734', '0735', '0736', '0737', '0742', '0743', '0744', '0746', '075', '0761', '0763', '0765', '0766', '0771', '0773', '0774', '0775', '0776', '0781', '0782', '0783', '0784', '0785', '0789', '079', '080', '081', '0823', '0824', '0825', '0827', '0828', '0831', '0832', '0833', '0835', '0836', '085', '0861', '0862', '0863', '0864', '0865', '0871', '0872', '0873', '0874', '0875', '0881', '0882', '0883', '0884', '0885', '089', '090', '091', '0921', '0922', '0923', '0924', '0925', '0931', '0932', '0933', '0934', '0935', '0941', '0942', '095', '0961', '0962', '0963', '0964', '0965', '0966', '0967', '0968', '0971', '0972', '0973', '0974', '0975', '0976', '0981', '0982', '0983', '0984', '0985', '099'];
        var mob = [
            { o: 'tim', t: ['330', '331', '333', '334', '335', '336', '337', '338', '339', '360', '361*', '362*', '363*', '366', '368', '385'] },
            { o: 'illiad', t: ['3513', '3514', '3515', '3516', '3517', '3518', '3519', '3520'] },
            { o: 'ferrovie', t: ['313'] },
            { o: 'vodafone', t: ['340', '341*', '342', '343*', '344', '345', '346', '347', '348', '349', '383*'] },
            { o: 'wind', t: ['320', '322*', '323*', '324', '327', '328', '329', '355*', '380', '388', '389'] },
            { o: 'tre', t: ['390*', '391', '392', '393', '397*'] },
            { o: '1mobile', t: ['3773', '3793'] },
            { o: 'btmobile', t: ['3710', '3777'] },
            { o: 'coopvoce', t: ['3311', '3703', '3534'] },
            { o: 'daily', t: ['3778'] },
            { o: 'fastw', t: ['373', '3755', '3756', '3757'] },
            { o: 'ho', t: ['3770', '3791', '3792'] },
            { o: 'kena', t: ['3500', '3501', '3505'] },
            { o: 'lyca', t: ['373', '3510', '3511', '3512', '382*'] },
            { o: 'Plintron', t: ['3760'] },
            { o: 'MassResponse', t: ['3780'] },
            { o: 'poste', t: ['3711', '3713', '3714', '3715', '3772', '3774', '3776', '3779'] },
            { o: 'tiscali', t: ['3701'] },
            { o: 'welcome', t: ['3783'] }
        ];
        var ret = { world: '+39', opePre: '', prefix: '', num: '', type: '', err: null, orig: '', code: EnmPhone.OK };

        var phoneRe = /^[\+]?[(]?[0-9]{2,4}[)]?[-\s\.]?[0-9]{2,4}[-\s\.]?[0-9]{2,8}$/im;
        if (tel) {
            tel = tel.replace(/[^+0-9]/g, '');
            if (tel.indexOf('0039') === 0) tel = tel.substring(4);
            if (tel.indexOf('+39') === 0) tel = tel.substring(3);
        }

        if (phoneRe.test(tel)) {
            var ch1 = pref.filter(v => {
                if (tel.indexOf(v) === 0) return v;
            });
            if (ch1.length > 0) {
                //fisso
                ret.type = 'F';
                ret.prefix = ch1[0];
                ret.orig = tel;
                ret.num = tel.substr(ch1[0].length);
                ret.label = ret.world + ' ' + ret.prefix + ' ' + ret.num;
                ret.raw = ret.prefix + ret.num;
            } else {
                //se è mobile
                var prefix = null;
                var found = null;
                var ope = null;
                mob.forEach(t => {
                    if (!prefix) {
                        var res = t.t.filter(v => {
                            if (!prefix) {
                                var re = '^(' + v.replace('*', '[0-9]{1,1}') + ')';
                                var patt = new RegExp(re);
                                var pm = patt.exec(tel);

                                if (pm && pm.length > 0) {
                                    ope = t.o;
                                    prefix = pm[0];
                                }
                            }
                        });
                    }
                });

                if (prefix) {
                    ret.type = 'M';
                    ret.ope = ope;
                    ret.prefix = prefix.substr(0, 3);
                    ret.opePre = prefix;
                    ret.orig = tel;
                    ret.num = tel.substr(ret.prefix.length);
                    ret.label = ret.world + ' ' + ret.prefix + ' ' + ret.num;
                    ret.raw = ret.prefix + ret.num;
                } else ret = { err: 'prefisso errato ' + tel, code: EnmPhone.KO };
            }
        } else ret = { err: 'telefono errato ' + tel, code: EnmPhone.KO };

        return ret;
    } catch (ex) {
        log("Error vefiy phone: ", ex, LogLvl.DEBUG);
    }
    return tel;

}*/

var gValidatePhone = (phone, country) => {

    // libphonenumber tollera alcuni caratteri alfabetici accodati al numero.
    // Li rifiutiamo prima del parsing per evitare falsi positivi.
    if (typeof phone !== 'string' || !/^[0-9+()./\s-]+$/.test(phone)) {
        return new Ret(EnmPhone.KO, null);
    }

    try {
        //validatePhoneNumberLength(phone, country); //eventualmente fa scattare eccezione

        const phoneParsed = parsePhoneNumber(phone, country);
        if (phoneParsed) {
            let ret = {};
            ret.valid = phoneParsed.isValid();
            ret.uri = phoneParsed.getURI();
            let natFormat = phoneParsed.formatNational();
            if (natFormat && natFormat !== null && natFormat.length > 0 && natFormat.indexOf(" ") > 0) {
                let fArr = natFormat.split(" ");
                ret.ext = fArr.shift();
                ret.number = fArr.join("");
            }
            ret.raw = phone;
            ret.type = phoneParsed.getType();
            return ret.valid ? new Ret(EnmPhone.OK, ret) : new Ret(EnmPhone.KO, ret);
        }

        return new Ret(EnmPhone.KO, null);

    } catch (ex) {
        return new Ret(EnmPhone.KO, ex);
    }


}

var validatePiva = (pi) => {

    if (pi && pi.length === 11) {

        if (!/^[0-9]{11}$/.test(pi)) {
            return EnmPiva.INVALID_LENGTH;
        }
        if ('00000000000' === pi) {
            return EnmPiva.KO;
        }

        var s = 0;
        for (var i = 0; i <= 9; i += 2) s += pi.charCodeAt(i) - '0'.charCodeAt(0);

        for (var i = 1; i <= 9; i += 2) {
            var c = 2 * (pi.charCodeAt(i) - '0'.charCodeAt(0));
            if (c > 9) c = c - 9;
            s += c;
        }
        var controllo = (10 - (s % 10)) % 10;
        if (controllo !== pi.charCodeAt(10) - '0'.charCodeAt(0)) {
            return EnmPiva.KO;
        }
        /*  try{
            if (!(pi.substr(7,3)>'000' && pi.substr(7,3)<'150')) window.iolpg_uti.logError('partita probabilmente errata '+ pi);
          }catch (ex) {
            window.iolpg_uti.logError('controllo add on iva user '+ ex);
          }*/
        if (pi.indexOf('8') === 0 || pi.indexOf('9') === 0) {
            return EnmPiva.NOCF;
        }

        return EnmPiva.OK;

    } else
        if (pi && pi.length === 7 && pi.indexOf('SM') === 0) {

            if (!/^SM[0-9]{5}$/.test(pi)) {
                return EnmPiva.INVALID_LENGTH;
            }

            return EnmPiva.OK;
        } else {
            return EnmPiva.KO;
        }
}

var cleanStrAddress = (a) => {
    a = a.trim();
    a = a.replace(/snc. /ig, '');
    a = a.replace(/Via |V. /ig, 'via ');
    a = a.replace(/Loc. /ig, 'località ');
    a = a.replace(/ViaLE |V.LE |Vl. /ig, 'viale ')
    a = a.replace(/P.ZA |Piazza /ig, 'piazza ');
    a = a.replace(/P.LE |piazzale /ig, 'piazzale ');
    a = a.replace(/CIRCONV. /ig, 'circonvallazione ');
    a = a.replace(/lungogmare |lungo mare |lgmare /ig, 'lungomare ');
    a = a.replace(/corte /ig, 'corte ');
    a = a.replace(/C.SO |corso /ig, 'corso ');
    a = a.replace(/L.GO |largo /ig, 'largo ');
    a = a.replace(/STR. |strada /ig, 'strada ');
    a = a.replace(/fratelli |F.LLI /ig, 'fratelli ');
    return a;
}

var cleanAddress = (address) => {
    var pm;
    var objRet = { topo: '', civico: '' };
    if (address) {
        if (address.indexOf(', ') === 0) address = address.substring(1);
        address = cleanStrAddress(address);
        //  address = address.trim();
        //  address = address.replace(/snc. /ig, '');

        pm = /((?!via)[^,]{0,4}[//0-9]+[^,]{0,4})[, ](.*)/gi.exec(address);  //16/a, Via Rutilia
        if (pm && pm.length === 3 && pm[0] === address) objRet = { topo: pm[2], civico: pm[1], pmo: 3, i: pm };
        else {
            pm = /([^0-9,]+)[, ]([^,]{0,4}[//0-9]+[^,]{0,4})/gi.exec(address);   //Via Lepontina, 8
            if (pm && pm.length === 3 && pm[0] === address) objRet = { topo: pm[1], civico: pm[2], pmo: 4, i: pm };
            else {
                pm = /([^,]*)[, ]([^,]{0,4}[/0-9]+[^,]{0,4})/gi.exec(address); //largo 11 Settembre 2001 12
                if (pm && pm.length === 3 && pm[0] === address) objRet = { topo: pm[1], civico: pm[2], pmo: 7, i: pm };
                else {
                    objRet = { topo: address, civico: '' };         //s.n.c.
                }
            }
        }

        objRet.topo = cleanStrAddress(objRet.topo);
    }

    objRet.topo = objRet.topo.trim();
    objRet.civico = objRet.civico.trim();
    objRet.fullAddress = objRet.topo + (objRet.civico ? ' ' + objRet.civico : '');
    return objRet;
}

var jsonSerialize = (obj, emp) => {
    var ret = '';
    if (emp) ret = JSON.stringify(obj, emp);
    else ret = JSON.stringify(obj);
    return ret;
}

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

function getStepByUrl() {
    let path = window.location.pathname;
    let selectedStep = Config.stepList.find(function (el) {
        var re = new RegExp(el.re);
        return re.test(path);
    })
    return selectedStep;
}

function generateCorrelationId(prefix) {
    var d = new Date();
    var n = d.getMilliseconds();
    return prefix + '' + Math.floor(Math.random() * 100000000) + '' + n;
}

function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value != null) ? unescape(value[1]) : null;
}

//--------------- GOOGLE ANALYTICS ----------------

function getChartType(prods) {  //------- CHECK TIPO CARRELLO
    let chartType = BasketType.PAY;

    let payProd = prods.find(function (el) {
        return el.type.code === BasketType.PAY.code
    });
    let prevProd = prods.find(function (el) {
        return el.type.code === BasketType.PREV.code
    });

    if (payProd && prevProd) {
        chartType = BasketType.BOTH;
    } else if (!payProd && prevProd) {
        chartType = BasketType.PREV;
    }
    //-------------------------------

    return chartType;
}

function gaException(funct, desc, isFatal, category) {
    log("== GA EXCEPTION:", desc, LogLvl.DEBUG);

    if (desc && desc.length > 0) {

        //---- ECCEZIONE SU GOOGLE ANALYTICS
        if (window.gtag) {

            let gaEnv = currEnv().gaEnv;
            let gaMeasurementId = currEnv().gaMeasurementId;

            //window.gtag('config', gaMeasurementId, {
            //    'custom_map': { 'dimension3': 'environment', 'dimension10': 'ExceptionCat' }
            //});

            window.gtag('event', 'exception', {
                "description": funct,
                "fatal": isFatal,
                "environment": gaEnv,
                "ExceptionCat": category,
				"ExceptionUA" : navigator && navigator.userAgent ? navigator.userAgent : "not set"
            });

        } else {
            log("GTAG not trovato", window.gtag, LogLvl.DEBUG);
        }

        //---- ECCEZIONE SU BACKEND IOL
        try {
            API.logException(category,funct,desc);
        } catch (e) {
            log("Error sending exception to be:" +  e.stack, LogLvl.ERROR);
        }

    }
}

function gaPurchase(transactionid, bskAndProds) {
    log("== GA PURCHASE:", bskAndProds, LogLvl.DEBUG);

    if (bskAndProds && bskAndProds.prodFiltered && bskAndProds.prodFiltered.length > 0) {

        let gaMeasurementId = currEnv().gaMeasurementId;
        let coupon = bskAndProds.coupon;
        let gaEnv = currEnv().gaEnv;
        let from = getCookie(FROM_COOKIE_NAME);
        //------- CHECK TIPO CARRELLO
        let chartType = getChartType(bskAndProds.prodFiltered);
        //-------------------------------

        //window.gtag('config', gaMeasurementId, {
        //    'custom_map': { 'dimension9': 'TipoCarrello', 'dimension3': 'environment', 'dimension7': 'from' }
        //});

        let items = [];
        bskAndProds.prodFiltered.forEach(p => {
            let item = {};
            item.id = p.code;
            item.name = p.description;
            item.quantity = p.qt;
            item.price = p.price;
            items.push(item);
        });

        if (window.gtag) {
            window.gtag('event', 'purchase', {
                "transaction_id": transactionid,
                "value": bskAndProds.amountVat,
                "currency": "EUR",
                "tax": bskAndProds.justVat,
                "shipping": 0,
                "items": items,
                "coupon": coupon,
                "TipoCarrello": chartType.code,
                "environment": gaEnv,
                "from": from
            });

        } else {
            log("GTAG not trovato", window.gtag, LogLvl.DEBUG);
        }


    } else {
        log("GA Track: prodotti not trovati", window.gtag, LogLvl.DEBUG);
    }
}

function gaCheckout(step, bskAndProds) {

    log("== GA CHECKOUT:", step, LogLvl.DEBUG);
    log("== GA CHECKOUT PRODS:", bskAndProds, LogLvl.DEBUG);

    if (window.gtag) {

        if (bskAndProds && bskAndProds.prodFiltered && bskAndProds.prodFiltered.length > 0) {

            let gaMeasurementId = currEnv().gaMeasurementId;
            let gaEnv = currEnv().gaEnv;
            let prods = bskAndProds.prodFiltered;
            let coupon = bskAndProds.coupon;
            let from = getCookie(FROM_COOKIE_NAME);
            //------- CHECK TIPO CARRELLO
            let chartType = getChartType(prods);
            //-------------------------------
            let payType = sessionStorage.getItem("payMethodType");

            //Setta la dimensione "TipoCarrello" in modo che possa essere registrata negli eventi del checkout.
            //window.gtag('config', gaMeasurementId, {
            //    'custom_map': { 'dimension9': 'TipoCarrello', 'dimension3': 'environment', 'dimension7': 'from' }
            //});

            let items = [];
            prods.forEach(p => {
                let item = {};
                item.id = p.code;
                item.name = p.description;
                item.quantity = p.qt;
                item.price = p.price;
                items.push(item);
            });

            if (step === 1) {
                //Load pagina fatturazione

                window.gtag('event', 'begin_checkout', {
                    "currency": "EUR",
                    "value": bskAndProds.amountVat,
                    "items": items,
                    "coupon": coupon,
                    "TipoCarrello": chartType.code,
                    "environment": gaEnv,
                    "from": from
                });


            } else if (step === 2) {
                //Load pagina metodo di pagamento

                // N.B. Commentato perché in GA4 non esiste questo step (checkout_progress non è implementata). 
                //GA
                /*
                window.gtag('event', 'checkout_progress', {
                    "checkout_step": step,
                    "items": items,
                    "coupon": coupon,
                    "TipoCarrello": chartType.code,
                    "environment": gaEnv,
                    "from": from
                });*/

                
                //FB
                if (typeof window.fbq !== "undefined") {
                    window.fbq('track', 'InitiateCheckout');
                }


            } else if (step === 3) {
                //Load pagina conferma pagamento

                // N.B. Commentato perché in GA4 non esiste questo step (checkout_progress non è implementata). 
                 // Si usa per lo step 2 il passaggio su scelta metodo pagamento "add_payment_info"
                //GA
                /*
                window.gtag('event', 'checkout_progress', {
                    "checkout_step": step,
                    "items": items,
                    "coupon": coupon,
                    "TipoCarrello": chartType.code,
                    "environment": gaEnv,
                    "from": from
                });*/

                window.gtag('event', 'add_payment_info', {
                    "currency": "EUR",
                    "value": bskAndProds.amountVat,
                    "items": items,
                    "coupon": coupon,
                    "payment_type": payType,
                    "TipoCarrello": chartType.code,
                    "environment": gaEnv,
                    "from": from
                });


                //FB
                if (typeof window.fbq !== "undefined") {
                    window.fbq('track', 'CompleteRegistration');
                }

            }

            //----- Pagina vista FAKE per poter fare obiettivi canalizzati sulle varie sigle prodotto
            let codes = normalizeProductsForAnalytics(prods);
            let stepByUrl = getStepByUrl();
            let path = stepByUrl.path + '#' + stepByUrl.gaCheckoutStep + '_' + codes;
            gaPageview(stepByUrl.desc, currEnv().domain + path, path);
            // --------------

        } else {
            log("GA Track: prodotti not trovati", window.gtag, LogLvl.DEBUG);
        }

    } else {
        log("GTAG not trovato", window.gtag, LogLvl.DEBUG);
    }

}

function normalizeProductsForAnalytics(prods) {
    const prodList = prods.map(item => {
        return item.code;
    }).sort();
    let codes = prodList.join(";");
    return codes;
}

function gaPageview(title, location, path) {

    //------ Traccia pagina vista su GA
    if (window.gtag) {
        log("== GA PAGEVIEW:", location, LogLvl.DEBUG);

        let gaMeasurementId = currEnv().gaMeasurementId;
        let gaEnv = currEnv().gaEnv;
        let from = getCookie(FROM_COOKIE_NAME);

        //window.gtag('config', gaMeasurementId, {
        //    'custom_map': { 'dimension3': 'environment', 'dimension7': 'from' }
        //});
        window.gtag('event', 'page_view', {
            page_title: title,
            page_location: location,
            page_path: path,
            send_to: gaMeasurementId,
            environment: gaEnv,
            from: from
        })

    } else {
        log("GTAG not trovato", window.gtag, LogLvl.DEBUG);
    }

}

//chiamata internamente alle funzioni negli stessi punti di GA
function wtPageview() {
    try {
        if (window.IOL && window.IOL.Analytics && window.IOL.Analytics.Tracking) {

            let bskAndProds = JSON.parse(sessionStorage.getItem(prodListName));
            let codes = "";
            let from = getCookie(FROM_COOKIE_NAME);

            if (bskAndProds && bskAndProds !== null && bskAndProds.prodFiltered && bskAndProds.prodFiltered.length > 0) {
                codes = normalizeProductsForAnalytics(bskAndProds.prodFiltered);
            } else {
                log("WT Track: prodotti not trovati", window.gtag, LogLvl.DEBUG);
            }

            log("== WT PAGEVIEW:", bskAndProds, LogLvl.DEBUG);
            window.iol_analytics_tracking_conf = window.iol_analytics_tracking_conf || {};
            window.iol_analytics_tracking_conf['customParams'] = {
                '47': from,
                '49': codes
            };
            var iat = new window.IOL.Analytics.Tracking.Engine();
            iat.send();
        } else {
            log("WT not trovato", window.gtag, LogLvl.DEBUG);
        }

    } catch (ex) {
        log("WT pageview track error", ex, LogLvl.ERROR);
    }
}

function checkState(value){
    var ret = false;
    try{
        var date = new Date();
        var now = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
        log("checkState start", value, LogLvl.DEBUG);

        if (window.IolState)
          window.IolState.forEach( state => { 
            if (state.state == value && state.start < now && state.end > now ) {
              log("checkState match", state, LogLvl.DEBUG);
              ret = true;
            }
          });

    } catch (ex) {
        log("checkState err", ex, LogLvl.ERROR);
    }
    return ret;
  }

  function gaTrackRegistrationFreeProd(step, prdCode, isLogged) {

    let lbLogged = isLogged ? "logged" : "notLogged";
    let path = "regFree_notset";

    if (step === "start") {
        path = "/regFree-start-" + prdCode + "-" + lbLogged;
    } else if (step === "end") {
        path = "/regFree-end-" + prdCode + "-" + lbLogged;
    } else if (step === "err") {
        path = "/regFree-err-" + prdCode + "-" + lbLogged;
    }

    let href = currEnv().domain + path;
    gaPageview("Registrazione prodotto free", href, path);

  }


  function resetBskAndHome(){
    API.basketDelAll((data) => {
        window.location.href = currEnv().businessHome;
    });
  }

  function getSessionId(){
    let id = sessionStorage.getItem(sessionIdName);
    if (!id || id.length <= 0) {
        id = uuidv4()
        sessionStorage.setItem(sessionIdName, id);
    }
    return id;
  }

//--------------------------------------------------

export default { ErrorMsgGen, Ret, EnmEmail, EnmPiva, EnmCf, EnmPhone, EnmGen, EnmSdi, EnmBasket, BasketType, currEnv, log, validatePiva, validateCf, validateEmail, validateSdi, LoadingInp, groupBy, DlgConf, LogLvl, cleanAddress, jsonSerialize, getStepByUrl, generateCorrelationId, selCCName, invoiceName, prodListName, EnmPay, EnmProdType, gValidatePhone, gaCheckout, gaPageview, wtPageview, gaPurchase, gaException, ExcCatgory, checkState, gaTrackRegistrationFreeProd, FROM_COOKIE_NAME, getCookie, resetBskAndHome, getSessionId }
